import React from 'react'
import PropTypes from 'prop-types'
import WithWindowSize from 'Components/WithWindowSize'
import ShowMore from 'Layout/ShowMore'

import { StatSummaryCard, getBuildingInsightMap } from 'Components/InvestorInsightCards'

import { _InsightCard } from './styles'
import { useConfiguration } from '../../../../root/ConfigurationProvider'


const InvestorInsights = ({ building, insightData, winWidth, mobileBrowser, isMobileApp }) => {
  const { PROPERTY_TYPE_PLURAL, PROPERTY_TYPE_SINGULAR } = useConfiguration()
  // InvestorInsights @todo remove this one
  if(!insightData) return ''
  let insightMap = []
  // console.log(winWidth)
  try {
    const addressTitle = building && building.primary_address ? building.primary_address.title : ''
    insightMap = getBuildingInsightMap(
      building,
      addressTitle,
      insightData,
      winWidth < 767,
      { PROPERTY_TYPE_PLURAL, PROPERTY_TYPE_SINGULAR },
      isMobileApp,
    )
  } catch(e) { /* error */ }
  const statCards = []
  insightMap.forEach((insight) => {
    const data = insight.getContent()
    if(data) {
      const { stat, sentence, baseOnText, sign = '', title, hTag } = data
      statCards.push((
        <_InsightCard key={title}>
          <StatSummaryCard
            value={typeof stat !== 'string' ? String(Number(stat)) : stat}
            title={title}
            content={sentence}
            postfix={data.postfix || insight.postfix}
            prefix={insight.prefix}
            sign={sign}
            baseOnText={baseOnText}
            hTag={hTag}
          />
        </_InsightCard>
      ))
    }
  })
  const minShow = mobileBrowser ? 4 : 6
  if(!statCards.length) return ''
  return (
    <ShowMore
      elements={statCards}
      buttonText={`Show All (${statCards.length - minShow})`}
      minShow={mobileBrowser ? 4 : 6}
    />
  )
}

InvestorInsights.propTypes = {
  building: PropTypes.shape({
    primary_address: PropTypes.shape({
      title: PropTypes.string,
    }),
  }),
  insightData: PropTypes.shape({}),
  mobileBrowser: PropTypes.bool,
  winWidth: PropTypes.number,
  isMobileApp: PropTypes.bool,
}

export default WithWindowSize(InvestorInsights)
